/** Keep JSON fields and repeated uploads compatible with the existing parser. */
export function buildMultipart(body: {
  config: string;
  permissions?: string;
  rooms?: string;
  images?: Blob[];
  'config-keys'?: string[];
}): FormData {
  const form = new FormData();
  form.append('config', body.config);
  if (body.permissions !== undefined) form.append('permissions', body.permissions);
  if (body.rooms !== undefined) form.append('rooms', body.rooms);
  for (const image of body.images ?? []) form.append('images', image);
  for (const key of body['config-keys'] ?? []) form.append('config-keys', key);
  return form;
}
